import { gql } from "@apollo/client"
import { getCollectionPointsByIds, getCollectionPointsByIdsVariables } from "./types/getCollectionPointsByIds"

export const GET_COLLECTION_POINTS_BY_IDS = gql`
  query getCollectionPointsByIds($ids: [ID!]!) {
    getCollectionPointsByIds(ids: $ids) {
      __typename
      id
      description
      street
      latitude
      longitude
      location_number
      cadastral_name
      cadastral_nr
      postal
      place
      town {
        __typename
        id
        name
      }
      next_emptying
      last_emptying
      collectionPointFilllevels(sorted: false) {
        __typename
        filllevel
        material_id
      }
      containers(sorted: false) {
        __typename
        id
        last_time_send
        material_id
        lid_open
        lid_changed
        sensor_id
        defectiveSensor
      }
      fixed_unload_interval
      collection_groups {
        __typename
        id
        label
        materials {
          __typename
          id
          name
        }
      }
    }
  }
`

export type GetCollectionPointsByIdsResult = getCollectionPointsByIds
export type GetCollectionPointsByIdsVars = getCollectionPointsByIdsVariables